import { IMultipleContentTypeResult } from '~src/httpClient/serverApi/types/IResponse';
import { RequestHelper } from '~src/httpClient/utils/RequestHelper';
import { ResultHelper } from '~src/httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import {
  ContainerType,
  ContentItem
} from '~src/projects/ServerApi/requests/MoveContentToContainerRequest';
import { RestoreContentToContainerRequest } from '~src/recycleBin/serverApi/requests/RestoreContentToContainerRequest';

export class RecycleBinResource {
  public restoreContentToContainer(containerId: string, containerType: string, contentItems: ContentItem[]): Promise<IMultipleContentTypeResult> {

    const requests = RequestHelper.buildRequests(
      contentItems,
      contentItemsBlock => new RestoreContentToContainerRequest({
        containerId: containerId,
        containerType: ContainerType[containerType as keyof typeof ContainerType],
        contentItems: contentItemsBlock})
    );
    return WebHttpClientWithErrorToastInstance
      .sendRequestsAndDelay(requests, ResultHelper.combineMultipleContentTypeResults);
  }
}

export const RecycleBin = new RecycleBinResource();